import { Container, Row, Col } from "react-bootstrap";
import image1 from "../assets/img/file.png";
import image2 from "../assets/img/system.png";
import image3 from "../assets/img/neofetch.png";
import image4 from "../assets/img/hardware.png";
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Demo = () => {
  return (
    <section className="skill" id = "demo">
      <Container>
      <div className="skill-bx wow zoomIn">
        <h2>Product</h2>
        <Row style={{ marginBottom: "20px" }}>
          <Col sm={6} md={6}>
            <img src={image1} alt="Image 1" />
          </Col>
          <Col sm={6} md={6}>
            <img src={image2} alt="Image 2" />
          </Col>
        </Row>
        <Row style={{ marginBottom: "20px" }}>
          <Col sm={6} md={6}>
            <img src={image3} alt="Image 3" />
          </Col>
          <Col sm={6} md={6}>
            <img src={image4} alt="Image 4" />
          </Col>
        </Row>
       </div>
          
        
      </Container>
    </section>
  );
};
